<form [formGroup]="negatievePGA">
  <div>
    <snelstart-ui-number-form-control formControlName="inkomstenSpecifiekeZiektekosten"
                                      id="inkomstenSpecifiekeZiektekosten"
                                      label="Terugontvangen zorgkosten"
                                      class="me-1 custom-input-200"
                                      [decimals]="0"
                                      align="right"
                                      prefix="€"
                                      (change)="saveForm()">
    </snelstart-ui-number-form-control>
  </div>
  <div>
    <snelstart-ui-number-form-control formControlName="inkomstenOverigGiften"
                                      id="inkomstenOverigGiften"
                                      label="Terugontvangen giften"
                                      class="me-1 custom-input-200"
                                      [decimals]="0"
                                      align="right"
                                      prefix="€"
                                      (change)="saveForm()">
    </snelstart-ui-number-form-control>
  </div>
  <div>
    <snelstart-ui-number-form-control formControlName="inkomstenOverigStudiekosten"
                                      id="inkomstenOverigStudiekosten"
                                      label="Terugontvangen scholingskosten"
                                      class="me-1 custom-input-200"
                                      [decimals]="0"
                                      align="right"
                                      prefix="€"
                                      (change)="saveForm()">
    </snelstart-ui-number-form-control>
  </div>
  <div>
    <snelstart-ui-number-form-control formControlName="terugontvangenAlimentatie"
                                      id="terugontvangenAlimentatie"
                                      label="Terugontvangen alimentatie"
                                      class="me-1 custom-input-200"
                                      [decimals]="0"
                                      align="right"
                                      prefix="€"
                                      (change)="saveForm()">
    </snelstart-ui-number-form-control>
  </div>
</form>
